import { useMemo } from 'react'

import { useReportData } from '../../../../../reports/hooks/useReportData'
import { PeriodValue } from '../../../../types/inputTypes'
import { useProfitAndLossFilters } from '../contexts/profitAndLossFiltersContext'
import { ProfitAndLossInputBalance, ProfitAndLossInputRowComponent } from '../types/inputTypes'
import { useFetchProfitAndLossReport } from './useFetchProfitAndLossData'

interface UseProfitAndLossDataReturn {
  allExpandableIds: string[]
  reportData: ProfitAndLossInputRowComponent[]
  periods: PeriodValue[]
  isLoading: boolean
}

export const useProfitAndLossData = (): UseProfitAndLossDataReturn => {
  const { appliedFilters } = useProfitAndLossFilters()
  const { data, isLoading } = useFetchProfitAndLossReport({ appliedFilters })

  const { allExpandableIds, reportData, periods } = useReportData<ProfitAndLossInputBalance>({
    data,
  })

  return useMemo(
    () => ({
      allExpandableIds,
      reportData,
      periods,
      isLoading,
    }),
    [allExpandableIds, reportData, periods, isLoading],
  )
}
